var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseReassignmnetBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.584 4.25H9.41732C8.00482 4.25 6.84648 4.25 5.88607 4.30625C4.17253 4.40729 3.08607 4.68854 2.30482 5.47083C1.08398 6.69062 1.08398 8.65521 1.08398 12.5833C1.08398 16.5115 1.08398 18.476 2.30482 19.6958C3.52565 20.9156 5.48919 20.9167 9.41732 20.9167H13.584C17.5121 20.9167 19.4767 20.9167 20.6965 19.6958C21.9163 18.475 21.9173 16.5115 21.9173 12.5833C21.9173 8.65521 21.9173 6.69062 20.6965 5.47083C19.9152 4.68958 18.8288 4.40833 17.1163 4.30625C16.1548 4.25 14.9965 4.25 13.584 4.25Z",
    stroke: "#1B385F",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88672 4.30625C6.74401 4.28542 7.5013 3.68125 7.79297 2.875L7.82943 2.76771L7.85547 2.6875C7.89922 2.55521 7.92214 2.48958 7.94505 2.43125C8.0922 2.06543 8.34014 1.74888 8.66007 1.51839C8.97999 1.2879 9.35875 1.15293 9.75234 1.12917C9.8138 1.125 9.88464 1.125 10.0221 1.125H12.9784C13.1169 1.125 13.1867 1.125 13.2492 1.12917C13.6428 1.15293 14.0216 1.2879 14.3415 1.51839C14.6614 1.74888 14.9094 2.06543 15.0565 2.43125C15.0805 2.48958 15.1023 2.55625 15.1461 2.6875L15.1732 2.76771C15.1919 2.82292 15.2003 2.85104 15.2096 2.875C15.5013 3.68229 16.2586 4.28542 17.1159 4.30625",
    stroke: "#1B385F",
    strokeWidth: 1.5625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5647 7.08301C18.4293 9.12051 16.8616 10.1393 15.2095 10.6528C12.7939 11.4033 10.2074 11.4033 7.7918 10.6528C6.13867 10.1393 4.57096 9.12155 1.43555 7.08301M7.33346 9.45801V11.5413M15.6668 9.45801V11.5413",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseReassignmnetBlueIcon);
export default __webpack_public_path__ + "static/media/CaseReassignmnetBlueIcon.239185671fbca72e71e57f979fa21ad7.svg";
export { ForwardRef as ReactComponent };